<template>
  <div class="mb-4">
    <div class="color-blue-green table-title mb-2">
      <strong v-text="data.title" />
    </div>
    <b-table-simple
      small
      responsive
      class="bg-white progress-table position-relative overflow-hidden"
    >
      <b-thead>
        <b-th class="border-0 text-secondary">{{ $lang.caption }}</b-th>
        <b-th v-if="isMoiProject" class="border-0 text-secondary text-center">
          {{ $lang.row_score }}
        </b-th>
        <b-th class="border-0 text-secondary text-center">
          {{ $lang.score }}
        </b-th>
        <b-th
          v-if="showProgress"
          class="border-0 text-secondary d-flex align-items-center justify-content-between px-0"
        >
          <span
            v-for="(item, index) in lineWhites"
            :key="index"
            class="line-white"
            v-text="item"
          />
        </b-th>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(row, index) in data.items" :key="index" class="bg-white">
          <b-td class="w-25">
            <strong v-text="`(${pathOr('', ['component_number'], row)})`" />
            <span
              class="ml-1"
              :class="titleClass"
              v-text="`${pathOr('', ['title'], row)}`"
            />
          </b-td>
          <b-td v-if="isMoiProject" class="w-10 text-center dir_ltr">
            {{ pathOr("", ["value"], row) }}
          </b-td>
          <b-td class="w-10 text-center dir_ltr">
            {{ generateRank(row) }}
          </b-td>
          <b-td v-if="showProgress" class="position-relative progress-parent">
            <span
              class="progress-td bg-blue-green"
              :style="`width: ${generateRankWidth(row)}%`"
            />
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import { pathOr, includes } from "ramda";
import { getProjectName } from "@/shared/utils";
import { toRefs, computed } from "vue";

export default {
  name: "percent-table",
  props: {
    data: {
      type: Object,
      default: null,
    },
    titleClass: {
      type: String,
      default: "",
    },
    frontPageName: {
      type: String,
      default: null,
    },
    showProgress: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    // bind props
    const { frontPageName } = toRefs(props);

    // check current project is moi
    const isMoiProject = computed(() => {
      const projectName = getProjectName();
      return projectName === "moi";
    });

    // check exam pack is type 3
    const isExamPackType3 = computed(() => {
      return frontPageName.value === "exam_pack_type_3";
    });
    const lineWhites = computed(() => {
      return isExamPackType3.value
        ? [1, 2, 3, 4, 5]
        : [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    });

    // generate rank number for show
    const generateRank = (row) => {
      const rankName = isExamPackType3.value ? "rank_value" : "rank_percent";
      return pathOr("", [rankName], row);
    };

    // generate rank width for chart
    const generateRankWidth = (row) => {
      const width = pathOr(0, ["rank_percent"], row);
      return isExamPackType3.value ? width * 2 : width;
    };

    return {
      pathOr,
      includes,
      isMoiProject,
      lineWhites,
      getProjectName,
      generateRank,
      generateRankWidth,
    };
  },
};
</script>
<style lang="scss" scoped>
.table-title {
  font-size: 18px;
}
.progress-table * {
  border-color: #0fb0af;
  .w-10 {
    width: 10%;
  }
  .line-white {
    width: 100%;
    text-align: left;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      width: 1px;
      height: 100%;
      background: white;
      margin-right: 15px;
      z-index: 1;
    }
  }
}
.progress-parent {
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(196, 196, 196, 1) 50%,
    rgba(255, 255, 255, 1) 100%
  );
}
.progress-td-default {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.progress-td {
  background-color: transparent;
  position: absolute;
  top: 15%;
  right: 0;
  height: 70%;
  width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-weight: bold;
  z-index: 2;
}
.bg-blue {
  background-color: #2f75b5 !important;
}
.bg-green {
  background-color: #00b050 !important;
}
.bg-red {
  background-color: #ff0000 !important;
}
.bg-blue-green {
  background-color: #0fb0af !important;
}
.color-blue-green {
  color: #0fb0af !important;
}
</style>
